var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-element-bottom d--grid"},[_c('div',[_c('el-link',{attrs:{"type":"info"},on:{"click":_vm.handleClear}},[_vm._v(_vm._s(_vm.$t('general.clear')))])],1),_vm._v(" "),_c('div',[_c('el-link',{attrs:{"type":"success"},on:{"click":_vm.handleApply}},[_vm._v(_vm._s(_vm.$t('general.apply')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }